/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

import { CircularProgress, Stack } from '@mui/material';
import { useQueries } from '@tanstack/react-query';

import Insights from './Insights';
import Issues from './Issues';
import { getInsights } from '../../axiosClient/draftApi';

interface IProps {
  activeTab: string;
  id?: string;
  sections?: any;
  openBoot: VoidFunction;
  setBotFrom: any;
}

const SectionList = (props: IProps) => {
  const { sections, id, activeTab, openBoot, setBotFrom } = props;

  const combinedQueries = useQueries({
    queries:
      sections && id
        ? sections.map((data: any) => {
            return {
              queryKey: ['insights-list', data.id, id],
              queryFn: () => getInsights(id, data.id),
            };
          })
        : [],
    combine: (results) => {
      return {
        data: results.map((result) => {
          return result.data as any[];
        }),
        pending: results.some((result) => result.isPending),
      };
    },
  });

  return (
    <>
      {combinedQueries.pending ? (
        <Stack style={{ padding: '5px' }}>
          <CircularProgress />
        </Stack>
      ) : (
        <>
          {activeTab === 'insights' && (
            <Insights
              insights={combinedQueries}
              openBoot={openBoot}
              setBotFrom={setBotFrom}
            />
          )}
          {activeTab === 'issues' && (
            <Issues
              issues={combinedQueries}
              openBoot={openBoot}
              setBotFrom={setBotFrom}
            />
          )}
        </>
      )}
    </>
  );
};

export default SectionList;
